// import {Platform} from "react-native";
//
// module.exports = Platform.OS === 'android' ? require("react-native-firebase") : null;


/**
 * @providesModule RNRestart
 */

'use strict';

import LottieView from "react-native-web-lottie";

//const LottieView  = LottieView;

export default LottieView;
